import { getWindow } from '@/helpers/globals'
import { useRoutes } from '@/router/routes'
import { useRouter } from 'vue-router'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'

export function useCloseFullscreenWizard() {
    const router = useRouter()
    const routerNavigation = useRouterNavigation()
    const sourceUrl = String(router.currentRoute.value.query['source'] || '')
    const routes = useRoutes()
    const window = getWindow()
    let close: () => void

    if (!sourceUrl) {
        close = () => {
            routerNavigation.routerPush(routes.home())
        }
    } else if (sourceUrl.startsWith('http')) {
        close = () => {
            if (!window) {
                return
            }

            window.location.href = sourceUrl
        }
    } else {
        close = () => {
            routerNavigation.routerPush(sourceUrl)
        }
    }

    return {
        close,
        sourceUrl,
    }
}
